import React, { useContext, useState } from 'react';
import { Pressable, Text } from 'react-native';

import AuthContext from 'app/src/contexts/AuthContext';
import { SubNavContainer, LinkContainer, LinkSpace } from 'app/src/elements';
import Modal from 'app/src/elements/Modal';
import { Link } from 'app/src/utils/routing';

import NewInvoice from './new';
import NewCreditMemo from '../CreditMemos/new';
import NewCustomerRefund from '../CustomerRefunds/new';

const SubNav = ({ refetch, screen }) => {
  const { hasPolicy } = useContext(AuthContext);
  const [showAddInvoiceModal, setShowAddInvoiceModal] = useState(false);
  const [showAddCreditMemoModal, setShowAddCreditMemoModal] = useState(false);
  const [showAddCustomerRefundModal, setShowAddCustomerRefundModal] =
    useState(false);

  return (
    <SubNavContainer>
      <LinkContainer>
        {hasPolicy({ type: 'Txn', action: 'create' }) && (
          <>
            <Pressable onPress={() => setShowAddInvoiceModal(true)}>
              <Text>+ Add Invoice</Text>
            </Pressable>
            <LinkSpace />

            {'Invoices' !== screen && (
              <>
                <Link to="/accounting/invoices">
                  <Text>Invoices</Text>
                </Link>
                <LinkSpace />
              </>
            )}

            <Pressable onPress={() => setShowAddCreditMemoModal(true)}>
              <Text>+ Add Customer Credit</Text>
            </Pressable>
            <LinkSpace />

            {'CreditMemos' !== screen && (
              <>
                <Link to="/accounting/credit-memos">
                  <Text>Customer Credits</Text>
                </Link>
                <LinkSpace />
              </>
            )}

            {'CustomerRefunds' === screen && (
              <>
                <Pressable onPress={() => setShowAddCustomerRefundModal(true)}>
                  <Text>+ Add Customer Refund</Text>
                </Pressable>
                <LinkSpace />
              </>
            )}

            {'CustomerRefunds' !== screen && (
              <>
                <Link to="/accounting/customer-refunds">
                  <Text>Refunds</Text>
                </Link>
                <LinkSpace />
              </>
            )}

            <Link to="/accounting/payments">
              <Text>Payments</Text>
            </Link>
            <LinkSpace />
          </>
        )}
      </LinkContainer>

      {showAddInvoiceModal &&
        <Modal
          setShowModal={setShowAddInvoiceModal}
          modalType="Add Invoice"
        >
          <NewInvoice
            setShowModal={setShowAddInvoiceModal}
            refetch={refetch}
          />
        </Modal>
      }

      {showAddCreditMemoModal &&
        <Modal
          setShowModal={setShowAddCreditMemoModal}
          modalType="Add Customer Credit"
        >
          <NewCreditMemo
            setShowModal={setShowAddCreditMemoModal}
            refetch={refetch}
          />
        </Modal>
      }

      {showAddCustomerRefundModal &&
        <Modal
          setShowModal={setShowAddCustomerRefundModal}
          modalType="Add Customer Refund"
        >
          <NewCustomerRefund
            setShowModal={setShowAddCustomerRefundModal}
            refetch={refetch}
          />
        </Modal>
      }
    </SubNavContainer>
  );
};

export default SubNav;
